"use strict";

import classnames from "classnames";
import assignIn from "lodash/assignIn";
import React from "react";

import {Card} from "@/components/card/Card.js";
import Utils from "@/legacy/Utils.js";
import {checkFeature, checkFeatures} from "@/pages/rum/v2/CheckFeatures.js";
import {RUMNeedHelp} from "@/pages/rum/v2/details/RUMNeedHelp.js";

import RUMDataDetail from "./RUMDataDetail.jsx";

export default class RumCheckDetailHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    Utils.autoBindClass(this);
  }

  render() {
    let data = this.props.data;

    // We want satisfaction as a percentage instead of raw value, so insert that as a new checkFeature.
    const satisfiedPct = checkFeature("satisfiedPct", "Satisfied", {
      units: "%",
      tooltipName: "% Satisfied (based on APDEX threshold)",
      inverse: true,
    });
    const satisfiedPctValue = (data[checkFeatures.satisfied.key] / data[checkFeatures.pageViews.key]) * 100;
    const satisfiedPctBaseline =
      (data[checkFeatures.satisfied.baseline] / data[checkFeatures.pageViews.baseline]) * 100;
    const satisfiedPctDPct = satisfiedPctValue - satisfiedPctBaseline; // Absolute change in %.
    data = assignIn({}, data, {
      [satisfiedPct.key]: satisfiedPctValue,
      [satisfiedPct.deltaPct]: satisfiedPctDPct,
    });
    const pageViewData = {
      data,
      primary: checkFeatures.pageViews,
      details: [checkFeatures.sessions, checkFeatures.bounceRate],
    };

    const pageLoadData = {
      data,
      primary: checkFeatures.tti,
      details: [checkFeatures.firstPaint, checkFeatures.apdex, satisfiedPct],
    };

    const ajaxData = {
      data,
      primary: checkFeatures.ajaxLoad,
      details: [checkFeatures.ajaxFirstByte],
    };

    const errorData = {
      data,
      primary: checkFeature("errors", "Errors"),
      tooltip: "Error rate breakdown",
      details: [checkFeatures.errorRate4xx, checkFeatures.errorRate5xx, checkFeatures.errorRateJS],
    };

    return (
      <>
        <RUMNeedHelp dismissible />
        <Card variant="white">
          <div className="rum-check-detail">
            <div className="header-item-wrapper row">
              {[pageViewData, pageLoadData, ajaxData, errorData].map((item, index) => (
                <div
                  key={index}
                  className={classnames("col-3 d-flex", {
                    "border-end": index < 3,
                  })}
                >
                  <RUMDataDetail data={item} isAjax={false} />
                </div>
              ))}
            </div>
          </div>
        </Card>
      </>
    );
  }
}
